import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLoginMutation } from "../../actions/authActions";
import requestForToken from "../../firebase_services/requestPermission";
import textWeight from "../../utils/textWeight";
import { useAuth } from "../../context/authContext";
export default () => {
  const { TextWeight } = textWeight();
  const { login } = useAuth();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [fcmToken, setFcmToken] = useState("");
  const emailData = useSelector((state) => state.app.emailData);
  const fetchToken = async () => {
    try {
      let token = await requestForToken();
      if (!token) {
        console.warn("FCM token not available, retrying...");
        await new Promise((resolve) => setTimeout(resolve, 2000)); // Wait and retry
        token = await requestForToken();
      }

      if (token) {
        setFcmToken(token);
        return token;
      } else {
        console.error("FCM token still unavailable. Setting fallback token.");
        setFcmToken(""); // Fallback
        return "";
      }
    } catch (error) {
      console.error("Error fetching FCM token:", error);
      setFcmToken("");
      return "";
    }
  };

  useEffect(() => {
    fetchToken();
  }, []);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });
  
  const mutation = useLoginMutation(
    login,
    dispatch,
    setLoading,
    location,
    navigate
  );

  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoading(true);
    mutation.mutate({
      username: data.username,
      password: data.password,
      token: fcmToken,
      device_type: "web",
    });
  };
  return {
    TextWeight,
    handleSubmit,
    onSubmit,
    control,
    emailData,
    errors,
    loading,
    navigate,
  };
};
